import { useCallback } from 'react';

import { useSearchParams } from 'react-router-dom';
import { Select, Text } from 'ui';

import { rewardDiningSortValidation } from '../../rewardFilterValidation';

const SortSelect = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const searchOrder = rewardDiningSortValidation.parse(searchParams.get('order'));

  const handleSortChange = useCallback(
    (value: string | null) => {
      const nextParams = new URLSearchParams(searchParams);
      if (value) {
        nextParams.set('order', value);
      } else {
        nextParams.delete('order');
      }
      setSearchParams(nextParams);
    },
    [searchParams, setSearchParams]
  );

  return (
    <Select
      value={searchOrder}
      data={[
        {
          label: 'Distance',
          value: 'distance',
        },
        {
          label: 'Highest Cashback',
          value: 'promotional_amount',
        },
        {
          label: 'Most Recent',
          value: 'created_at',
        },
      ]}
      leftSection={
        <Text fz="sm" ml="xl">
          Sort By
        </Text>
      }
      onChange={handleSortChange}
      allowDeselect={false}
    />
  );
};

export { SortSelect };
